import React from "react";
import { Button } from "reactstrap";
import MedicinePrescriptionPanel from "./MedicinePrescriptionPanel";


// Custom styles for the drawer
const drawerStyles = `
.slide-panel {
    position: fixed !important;
    top: 0 !important;
    right: -100% !important;
    width: 100% !important;
    height: 100vh !important;
    background: white !important;
    z-index: 9999 !important;
    transition: right 0.3s ease-in-out !important;
    display: flex !important;
    flex-direction: column !important;
    overflow: hidden !important;
}

.slide-panel.open {
    right: 0 !important;
}

.slide-panel-content {
    flex: 1 1 auto !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    height: 100% !important;
}

.medicine-list {
    background: #f8f9fa;
    height: 100%;
    overflow-y: auto;
}

.medicine-item {
    transition: all 0.2s ease;
}

.medicine-item:hover {
    background: #fff;
}

.medicine-item.active {
    background: #e9ecef;
    border-right: 3px solid #556ee6;
}

.prescription-details {
    background: #fff;
}
`;

// Add styles to document
if (typeof document !== 'undefined' && !document.getElementById('drawer-styles')) {
    const styleSheet = document.createElement('style');
    styleSheet.id = 'drawer-styles';
    styleSheet.textContent = drawerStyles;
    document.head.appendChild(styleSheet);
}

const RemarksDrawer = ({ isOpen, onClose, data }) => {
    return (
        <div className={`slide-panel ${isOpen ? 'open' : ''}`}>
            <div className="slide-panel-content">
                <MedicinePrescriptionPanel 
                    isOpen={isOpen}
                    onClose={onClose}
                    data={data}
                />
            </div>
        </div>
    );
};

export default RemarksDrawer;
